module.exports = __webpack_public_path__ + "img/check-icon.951754f8.svg";